import React from "react";

const Returns = React.lazy(() => import("./IncludeReturns"));
const IBBills = React.lazy(() => import("./IBBills"));
const PlanDate = React.lazy(() => import("./PlanDateForm"));

const COLUMN_CONFIG = {
  SAIA: "SAIA",
  DEFAULT: "DEFAULT",
};

const APP_DATE_FORMAT = "yyyy-MM-dd";

const FFE_STEPS = [{ stepLabel: "Choose Plan Date", StepComponent: PlanDate }];
const DEFAULT_STEPS = [
  { stepLabel: "Choose Plan Date", StepComponent: PlanDate },
  { stepLabel: "Returns", StepComponent: Returns },
  { stepLabel: "IB Bills - No ETA", StepComponent: IBBills },
];

export { COLUMN_CONFIG, APP_DATE_FORMAT, FFE_STEPS, DEFAULT_STEPS };
